import { FieldHint, FieldLabel } from '@/components/ui/text';
import { TagField } from '@/components/ui/tag-field';
import { TemplateFeaturePicker } from '../TemplateFeaturePicker';
import { MAX_TEMPLATE_TAGS } from '../templateOptions';
import { FIELD_ERROR_MESSAGES, type FieldKey } from '../validation';
import { FieldError, RequiredMark } from '../FieldMarks';

interface Props {
  features: string[];
  tags: string[];
  errors: Set<FieldKey>;
  onChange: (patch: { features?: string[]; tags?: string[] }) => void;
}

export function TemplateFeaturesStep({ features, tags, errors, onChange }: Props) {
  return (
    <div className="h-full flex flex-col gap-5 min-w-0">
      <div>
        <FieldLabel>
          Features it shows off
          <RequiredMark />
        </FieldLabel>
        <FieldHint>
          Tick what a creator opening this template would come to learn. Reviewers check these
          against the story.
        </FieldHint>
        <div className="mt-3.5">
          <TemplateFeaturePicker
            value={features}
            onChange={(next) => onChange({ features: next })}
          />
        </div>
        {errors.has('templateFeatures') && (
          <FieldError>{FIELD_ERROR_MESSAGES.templateFeatures}</FieldError>
        )}
      </div>

      <div className="border-t-lureo-border-width border-lureo-line pt-4 max-w-[26rem]">
        <FieldLabel mb>
          Tags
          <RequiredMark />
          <span className="normal-case tracking-normal font-normal ml-1">
            — {tags.length} of {MAX_TEMPLATE_TAGS}
          </span>
        </FieldLabel>
        <TagField
          value={tags}
          invalid={errors.has('templateTags')}
          maxTags={MAX_TEMPLATE_TAGS}
          onChange={(next) => onChange({ tags: next })}
        />
        {errors.has('templateTags') ? (
          <FieldError>{FIELD_ERROR_MESSAGES.templateTags}</FieldError>
        ) : (
          <FieldHint>
            {tags.length >= MAX_TEMPLATE_TAGS
              ? `${MAX_TEMPLATE_TAGS} is the maximum. Remove one to add another.`
              : `Up to ${MAX_TEMPLATE_TAGS}. Creators search the gallery by these.`}
          </FieldHint>
        )}
      </div>
    </div>
  );
}
